import { module as BaseModule } from 'modujs';
import { debounce } from '../utils/tickers';

export default class extends BaseModule {
  constructor(m) {
    super(m);

    this.events = {
      click: {
        country: 'setCountry',
        loadMore: 'getMoreSchools',
      },
    };

    this.params = new URLSearchParams();
    this.search = this.$('search')[0];
    this.loadMore = this.$('loadMore')[0];
    this.schoolList = this.$('schools')[0];
  }

  setCountry( event ) {
    const selectedCountry = event.target.dataset.name;
    const currentCountry = this.$('country.is-active')[0];

    // Do nothing if clicking on the same country button
    if ( selectedCountry !== currentCountry.dataset.name ) {
      currentCountry.classList.remove('is-active');
      event.target.classList.add('is-active');

      if ( this.params.has('offset') ) {
        this.params.delete('offset');
      }

      this.getSchools();
    }
  }

  getSchools() {
    const country = this.$('country.is-active')[0].dataset.name;
    const query = this.search.value;
    const loadMoreLabel = this.loadMore.innerText;

    if ( ! this.params.has('offset') ) {
      this.schoolList.innerHTML = '';
    }

    this.loadMore.innerText = 'Cargando...';
    this.loadMore.classList.remove('u-hidden');

    let total_pages, total_schools;

    this.params.set( 'country', country );
    this.params.set( 'search', query );

    fetch( `${RSQ_XHR.api}rs/v1/schools?${ this.params.toString() }`, {
      method: 'GET'
    } )
      .then( res => {
        //total_pages = res.headers.get('X-WP-TotalPages');
        total_schools = res.headers.get('X-WP-Total');
        return res.ok ? res.json() : Promise.reject(res)
      } )
      .then( data => {
        let noResults = false;
        let newList = '';
        let currentList = this.schoolList.innerHTML

        for (let school in data) {
          newList += `
            <li class="c-schools_item">
              <a class="c-schools_item_link" href="${ data[ school ].url}" rel="external" target="_blank">
                <h3 class="c-schools_item_name">${ data[ school ].name }</h3>
                <p class="c-schools_item_country">${ data[ school ].country }</p>
                <div class="c-schools_item_image">
                  ${ data[ school ].logo.src !== '' ? `<img src="${ data[ school ].logo.src }" alt="" />` : '' }
                </div>
              </a>
            </li>
          `;
        }

        if ( 0 === data.length ) {
          newList += `
            <li class="c-schools_item -notfound">
              <p class="c-schools_item_name">Sin resultados</p>
            </li>
          `
          noResults = true;
        }

        if ( this.params.has('offset') ) {
          this.schoolList.innerHTML = currentList + newList;
        } else {
          this.schoolList.innerHTML = newList;
        }

        if (noResults) {
          this.loadMore.classList.add('u-hidden');
        } else {
          const resultsCount = this.schoolList.children.length;

          if ( resultsCount < total_schools ) {
            this.loadMore.classList.remove('u-hidden');
          } else {
            this.loadMore.classList.add('u-hidden');
          }
        }

        this.loadMore.innerText = loadMoreLabel;
      } )
      .catch( error => {
        throw Error( error.message );
      } )
    ;
  }

  getMoreSchools( event ) {
    const offset = this.schoolList.children.length;

    this.params.set( 'offset', offset );

    this.getSchools();
  }

  initEvents() {
    this.search.addEventListener( 'input', debounce( ev => {
      if ( this.params.has('offset') ) {
        this.params.delete('offset');
      }

      this.getSchools();
    }, 600 ) );
  }

  init() {
    this.initEvents();
  }
}
